module.exports = __webpack_public_path__ + "static/media/GLASS_POOL.752f84a8.jpg";